export default __webpack_public_path__ + "static/media/cricfantasy.940d1f23.png";